import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import classes from "./export_modal.module.css";
import util from "../../../styles/utilities.module.css";
import Select from "react-select";
import { exportFormatOptions } from "../../../constants";

const ExportModal = ({ isOpen, backHandler, continueHandler, exportType, exportTypeHandler, exportCount, submitForSharingHandler, submitForSharingDescription, setSubmitForSharingDescription }) => {

    const { passage, mcCount, ffCount, tfCount, fbCount } = exportCount || {};
    const [userInfo, setUserInfo] = useState(null);
    const [includeShareOption, setIncludeShareOption] = useState(false);
    const [isSubmitForSharing, setIsSubmitForSharing] = useState(false);
    const [groupName, setGroupName] = useState('');

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user")).userData;
        setUserInfo(user);
        const userGroup = user?.user_options?.user_group?.toLowerCase();
        if (userGroup.startsWith("cy")) {
            setIncludeShareOption(true);
            setGroupName("City Year");
        }
        if (userGroup.startsWith("bt")) {
            setIncludeShareOption(true);
            setGroupName("Breakthrough");
        }
    }, []);    

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`${util.modalOverlay} ${classes["modal-overlay"]}`}>
            <div className={`${util.modalSurface} ${classes.modal}`}>

                <p className={classes.text}>
                    Select export format:
                </p>
                <Select
                    value={exportType ? { label: exportType, value: exportType } : ''}
                    onChange={exportTypeHandler}
                    options={exportFormatOptions}
                    className={classes.select}
                    placeholder="-Select-"
                />
                <p className={classes.exportParagraph}>
                    {`The following will be included in your exported file: ${passage ? 'passage, ' : ''} ${mcCount} multiple-choice questions, ${ffCount} short-answer questions, ${tfCount} true-false questions, ${fbCount} fill in the blank questions.`}
                </p>

                {/* Checkbox for sharing creation with colleagues (only display for certain usergroups) */}
                { (includeShareOption) &&

                    <div>

                        <label className={classes["checkbox-container"]}>
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    setIsSubmitForSharing(isChecked);
                                    submitForSharingHandler(isChecked);
                                    if (!isChecked) {
                                        setSubmitForSharingDescription('');
                                    }
                                }}
                            />
                            <span className={classes["checkmark"]}></span>
                            {`Submit this creation for inclusion in ${groupName} example carousel`}
                        </label>

                        {/* Description text box - only show when checkbox is checked */}
                        {isSubmitForSharing && (
                            <div style={{ marginTop: '0px', paddingRight: 'var(--space-2)', boxSizing: 'border-box' }}>
                                <textarea
                                    value={submitForSharingDescription}
                                    onChange={(e) => setSubmitForSharingDescription(e.target.value)}
                                    placeholder="Briefly highlight for your peers what makes this creation unique and engaging."
                                    rows={3}
                                    style={{
                                        width: '100%',
                                        padding: 'var(--space-2)',
                                        borderRadius: 'var(--radius-sm)',
                                        border: '1px solid var(--color-border)',
                                        fontSize: '14px',
                                        fontFamily: 'inherit',
                                        resize: 'vertical',
                                        boxSizing: 'border-box'
                                    }}
                                />
                            </div>
                        )}
                    </div>

                }


                <div className={classes.confirmationBtnContainer}>
                    <button onClick={backHandler} type="button" className={`${classes.leftBtn} ${util.btn} ${util['btn--ghost']}`}>{'Cancel'}</button>
                    <button onClick={continueHandler} type="button" className={`${classes.rightBtn} ${util.btn}`}>{'Continue'}</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ExportModal;
